import { useNavigationBlockerViaHistory, useOnline } from '@libs/hooks';
import { isShowChallenge, selectRootWidgetUids, useAppDispatch, useAppSelector } from '@libs/store';
import { SystemEventTypeEnum } from '@libs/types';
import { ConditionalRender, eventBus } from '@libs/utils';
import React, { useLayoutEffect } from 'react';
import { WidgetsList } from '../widgets/WidgetsList';
import { Challenge, Offline, PortalWrapper, Provider, WidgetWrapper } from './index';

export function App() {
    const rootWidgetUids = useAppSelector(selectRootWidgetUids);
    const statusShowChallenge = useAppSelector(isShowChallenge);
    const dispatch = useAppDispatch();
    const isOnline = useOnline();
    useNavigationBlockerViaHistory(true);

    useLayoutEffect(() => {
        let documentScrolled = false;
        const handleScroll = () => {
            const scrolled = window?.scrollY !== 0;
            if (documentScrolled !== scrolled) {
                documentScrolled = scrolled;
                eventBus.emitGeneral(SystemEventTypeEnum.SCROLLED, scrolled);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [dispatch]);

    return (
        <Provider>
            <Offline />
            <Challenge />
            <ConditionalRender condition={isOnline && !statusShowChallenge}>
                <WidgetWrapper>
                    <PortalWrapper>
                        <WidgetsList uids={rootWidgetUids} />
                    </PortalWrapper>
                </WidgetWrapper>
            </ConditionalRender>
        </Provider>
    );
}
